/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ClassroomdisciplineQueryResponse,
  GetApiV1ClassroomdisciplineQueryParams,
  GetApiV1Classroomdiscipline401,
  GetApiV1Classroomdiscipline500,
} from "../../types/classPlanningController/GetApiV1Classroomdiscipline.ts";

function getGetApiV1ClassroomdisciplineUrl() {
  const res = { method: "GET", url: `/api/v1/classroomdiscipline` as const };
  return res;
}

/**
 * @description Lista paginada com filtros por empresa, curso, turma, módulo, status, datas, disciplina, polo e professor. **(Requer Authorization para autenticação)**
 * @summary Listar planejamentos (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline}
 */
export async function getApiV1Classroomdiscipline(
  params?: GetApiV1ClassroomdisciplineQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ClassroomdisciplineQueryResponse,
    ResponseErrorConfig<
      GetApiV1Classroomdiscipline401 | GetApiV1Classroomdiscipline500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ClassroomdisciplineUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
